export const API = "https://admin.bab-media.com/public/api/";
// Live URL
// export const API =
//   "https://bab-digital.design-services-online.com/bab-digital-dev/public/api/";
// Staging URL
export const DetailPageUrl = "https://bab-media.com/#/Detail";
